import {
  Popover,
  Box,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Button,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { ArrowForward, Notifications } from "@mui/icons-material";
import { useState } from "react";

const notifications = [
  // {
  //   id: 1,
  //   title: "Tugas Baru",
  //   message: "Kamu mendapatkan tugas baru hari ini.",
  //   read: false,
  //   time: "1 jam lalu",
  // },
  // {
  //   id: 2,
  //   title: "Komentar",
  //   message: "Ada komentar pada tugas 'Landing Page'.",
  //   read: true,
  //   time: "2 jam lalu",
  // },
  // {
  //   id: 3,
  //   title: "Deadline",
  //   message: "Tugas 'Dashboard Admin' akan jatuh tempo besok.",
  //   read: false,
  //   time: "3 jam lalu",
  // },
  // {
  //   id: 4,
  //   title: "Deadline",
  //   message: "Tugas 'Dashboard Admin' akan jatuh tempo besok.",
  //   read: false,
  //   time: "4 jam lalu",
  // },
];

const NotificationPopover = ({ open, anchorEl, onClose }) => {
  const theme = useTheme();
  const [showAll, setShowAll] = useState(false);

  const displayedNotifications = showAll
    ? notifications
    : notifications.slice(0, 3);
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          width: 360,
          maxHeight: 500,
          overflow: "hidden",
          borderRadius: "12px",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
          p: 0,
          border: "1px solid",
          borderColor: theme.palette.divider,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "background.paper",
          borderBottom: "1px solid",
          borderColor: theme.palette.divider,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Notifications
        </Typography>
      </Box>

      {/* Scrollable Notification List */}
      <Box
        sx={{
          overflowY: "auto",
          flex: 1,
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-track": {
            background: theme.palette.grey[100],
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.grey[300],
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.grey[400],
          },
        }}
      >
        {notifications.length > 0 ? (
          <List sx={{ p: 0 }}>
            {displayedNotifications.map((notif) => (
              <ListItem
                key={notif.id}
                alignItems="flex-start"
                sx={{
                  p: 1,
                  alignItems: "flex-start",
                  transition: "background-color 0.2s",
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.05),
                  },
                  ...(!notif.read && {
                    bgcolor: alpha(theme.palette.primary.light, 0.08),
                    borderLeft: `3px solid ${theme.palette.primary.main}`,
                  }),
                }}
              >
                <ListItemAvatar sx={{ minWidth: 48 }}>
                  <Avatar
                    sx={{
                      bgcolor: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.main,
                      width: 36,
                      height: 36,
                    }}
                  >
                    {notif.icon || <Notifications fontSize="small" />}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" component="span">
                      {notif.title}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography
                        variant="body2"
                        component="span"
                        sx={{
                          color: "text.secondary",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {notif.message}
                      </Typography>
                      <Typography
                        variant="caption"
                        component="span"
                        sx={{
                          mt: 0.5,
                          display: "block",
                          color: "text.disabled",
                        }}
                      >
                        {notif.time}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box sx={{ py: 5, textAlign: "center", color: "text.secondary" }}>
            <Typography variant="body1">No notification</Typography>
          </Box>
        )}
      </Box>

      {/* Footer */}
      {notifications.length > 3 && !showAll && (
        <Box
          sx={{
            p: 1.5,
            textAlign: "center",
            borderTop: "1px solid",
            borderColor: theme.palette.divider,
          }}
        >
          <Button
            size="small"
            endIcon={<ArrowForward fontSize="small" />}
            sx={{ fontWeight: 600 }}
            onClick={() => {
              setShowAll(true);
            }}
            // onClick={() => {
            //   onClose();
            //   // Optional: redirect
            //   // window.location.href = "/notifikasi";
            // }}
          >
            View All Notifications
          </Button>
        </Box>
      )}
    </Popover>
  );
};

export default NotificationPopover;
